import React, { useState } from 'react';
import axios from 'axios';
import Logo from "../components/assets/login-avator.jpg";
import { Link, useNavigate } from 'react-router-dom';

const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "",
        campany_name: "",
        password1: "",
        password2: "",
        role: "user"
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        // Validate form
        if (!formData.email || !formData.campany_name || !formData.password1 || !formData.password2) {
            setLoading(false);
            return setError("All fields are required");
        }

        if (formData.password1 !== formData.password2) {
            setLoading(false);
            return setError("Passwords do not match");
        }

        if (formData.password1.length < 4) {
            setLoading(false);
            return setError("Password must be at least 4 characters");
        }

        try {
            // Call register API
            const response = await axios.post('https://backend-livestream-production.up.railway.app/api/register-user', {
                email: formData.email,
                campany_name: formData.campany_name,
                password1: formData.password1,
                password2: formData.password2,
                role: formData.role
            });

            if (response.data.ok === 1) {
                alert("Registration successful!");
                navigate("/login");
            } else {
                setError(response.data.error || "Registration failed");
            }
        } catch (err) {
            console.error("Registration error:", err);
            setError(err.response?.data?.error || "Failed to register. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className='card'>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-md-6 d-flex justify-content-center'>
                            <img src={Logo} alt="Login Avatar" className="img-fluid rounded" 
                                 style={{ maxWidth: '100%', height: 'auto' }} />
                        </div>
                        <div className='col-md-6'>
                            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%' }}>
                                <h2 className="text-center mb-4">Sign Up</h2>
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Company Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            name="campany_name"
                                            value={formData.campany_name}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            name="password1"
                                            value={formData.password1}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Confirm Password</label>
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            name="password2"
                                            value={formData.password2}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary w-100"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Registering...
                                            </>
                                        ) : "Register"}
                                    </button>
                                </form>
                                <div className="text-center mt-3">
                                    <small>Already have an account? <Link to="/login">Sign In</Link></small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;